import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetchResults } from '../../../store/actions/resultsActions'
import ArrowIcon from '../../elements/icons/ArrowIcon'
import Loader from '../../elements/Loader';
import { tableHeadersFields } from '../../../utils';
import EmptyState from '../../elements/EmptyState';
import DataTable from '../../elements/DataTable';
import moment from 'moment';
import StudentResult from './StudentResult';
import ModalDialog from '../../layouts/ModalDialog';

const StudentResults = ({student, toggleTab}) => {
    const dispatch = useDispatch()
    const resultsSelector = useSelector(state => state.results) 
    const [page, setPage] = React.useState(1)
    const [perPage, setPerPage] = React.useState(10)

    useEffect(() => {
        dispatch(fetchResults(`studentId=${student._id}`, page, perPage))
    }, [student._id, dispatch, page, perPage])

    const columnWidths = {
        term: "w-2/12",
        session: "w-2/12",
        class: "w-1/12",
        totalSubjects: 'w-2/12',
        passedSubjects: 'w-2/12',
        sessionFinals: "w-2/12",
        date: 'w-1/12',
    }
        
    const tableOptions = {
      selectable: false,
      clickableRows: true,
      rowAction: (index)=>{
        openResult(resultsSelector?.results?.results[index])
      }
    }
    
    const columnDataStyles = {}
    
    const cleanupData = (dataSet) => {
        if(!dataSet) return []
        const data = []
        dataSet.forEach((item, itemIndex) => {
            data.push(
                {
                    term: item.term.name,
                    session: item.academicSession.name,
                    class: item.class.name,
                    totalSubjects: item.subjectBreakdown.length,
                    passedSubjects: item.subjectBreakdown.filter(sub => sub.passingGrade)?.length,
                    sessionFinals: item.finalTermResult ? 'Yes' : 'No',
                    date: moment(item.createdAt).format('DD/MM/YYYY'),
                },
            )
        })
    
        return data
    }

    const [activeResult, setActiveResult] = React.useState(null)
    const [resultOpen, setResultOpen] = React.useState(false)

    const openResult = (result) => {
        setActiveResult(result)
        setTimeout(() => {
            setResultOpen(true)
        }, 200)
    }

    const closeResult = () => {
        setResultOpen(false)
        setTimeout(() => {
            setActiveResult(null)
        }, 200)
    }

    return (
        <>
            <button onClick={()=>{toggleTab('academics')}} className="flex mt-2 mb-4 text-[13px] font-medium font-space-grotesk items-center gap-x-2 text-gray-400 hover:text-gray-700 transition duration-400">
                <ArrowIcon className="w-4 h-4 -rotate-180" />
                Back to Student Academics
            </button>
            
            <div className="w-full">
                <div className='pb-3 mb-2'>
                    <div className="w-full mx-auto">
                        <div className='w-full flex items-start justify-between'>
                            <div className='w-2/3'>
                                <h4 className='font-medium text-lg mb-1 text-gray-600'>Student Results</h4>
                                <div className=''>
                                <p className='text-gray-600 text-sm'>
                                    All results for this student from their admission to date are displayed below.
                                </p>
                                </div>
                            </div>
                            <div className='w-full flex flex-row-reverse gap-x-[5px]'>
                                
                            </div>
                        </div>
                    </div>
                </div>
                <div className="w-full">
                    {resultsSelector?.loadingResults ? 
                        <Loader />
                        :
                        <div className="w-full">
                            {resultsSelector?.results?.results?.length > 0 ? <>
                            <DataTable
                                tableHeaders={tableHeadersFields(cleanupData(resultsSelector?.results?.results)[0]).headers} 
                                tableData={cleanupData(resultsSelector?.results?.results)} 
                                columnWidths={columnWidths}
                                columnDataStyles={columnDataStyles}
                                allFields={tableHeadersFields(cleanupData(resultsSelector?.results?.results)[0]).fields}
                                onSelectItems={()=>{}}
                                tableOptions={tableOptions}
                                pagination={{
                                    perPage: perPage, 
                                    currentPage: page,
                                    totalItems: resultsSelector.results.total,
                                }}
                                changePage={(page) => {setPage(page)}}
                                updatePerPage={(perPage) => {setPerPage(perPage)}}
                            />
                        </>
                        :
                        <div>
                            <EmptyState 
                                emptyStateTitle={`No Results found`} 
                                emptyStateText={`No results have been recorded for ${student.firstName} ${student.lastName} yet`} />
                        </div>
                        }
                        </div>
                    }
                </div>
            </div>

            {activeResult !== null && (
            <ModalDialog
                shown={resultOpen} 
                closeFunction={()=>{closeResult()}} 
                actionFunction={()=>{}} 
                actionFunctionLabel={``}
                maxWidthClass='max-w-6xl'
                hideActions={true}
            >
                <StudentResult 
                    student={student} 
                    resultId={activeResult?._id} 
                    close={()=>{closeResult()}} 
                /> 
            </ModalDialog>
            )}
        </>
    )
}

export default StudentResults